export enum ELocales {
  DE = 'de-CH',
  US = 'us-EN',
}
